// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { CoreState, selectCanAccessRoute, GoAction } from '../state';

@Injectable()
export class PermissionsGuardService implements CanActivate {
  constructor(private store: Store<CoreState>) {}

  canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const route = this.getActivatedModuleRoute(router);
    const canAccess$ = this.store.pipe(select(selectCanAccessRoute(route)));
    return canAccess$.pipe(
      tap(canAccess => {
        if (!canAccess) {
          this.store.dispatch(new GoAction(['']));
        }
      })
    );
  }

  private getActivatedModuleRoute({ routeConfig }: ActivatedRouteSnapshot) {
    if (routeConfig === null) {
      return '';
    }
    return routeConfig.path || '';
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/permissions-guard.service.ts